//TODO move rest of code from range-selector.js here

module.exports = RangeSelector;

function RangeSelector() {}

RangeSelector.getRangeDisplayString = function(lowestNote, highestNote) {
	var bothEnabled = lowestNote && highestNote;
	if (bothEnabled) {
		if (!lowestNote.exactMatch && !highestNote.exactMatch) {
			return lowestNote.note + lowestNote.octave + ' - ' + highestNote.note + highestNote.octave;
		}
	}

	var str = '';

	if (lowestNote) {
		str += 'Lowest note: ' +lowestNote.note + lowestNote.octave + (lowestNote.exactMatch ? ' exactly': ' or higher');
	}

	if (bothEnabled) str += ', ';

	if (highestNote) {
		str += 'Highest note: ' +highestNote.note + highestNote.octave + (highestNote.exactMatch ? ' exactly': ' or lower');
	}

	return str;
};